import { styled } from '@linaria/react';
import React from 'react';
import Typography from '../Typography';

const ContentContainer = styled.div<Pick<TitleAndDescriptionProps, 'margin' | 'padding'>>`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 16px;
  margin: 0 0 24px 0;
  @media screen and (min-width: 768px) {
    margin: ${(props) =>
      typeof props.margin === 'number'
      ? props.margin + 'px'
      : typeof props.margin === 'string'
      ? props.margin
      : '0'};
    padding: ${(props) =>
      typeof props.padding === 'number'
        ? props.padding + 'px'
        : typeof props.padding === 'string'
        ? props.padding
        : '0'};
  }
`;

export interface TitleAndDescriptionProps {
  title: string;
  description: string;
  descriptionMaxWidth?: number;
  margin?: number | string;
  padding?: number | string;
}

function TitleAndDescription({
  title,
  description,
  descriptionMaxWidth,
  margin,
  padding,
  ...props
}: TitleAndDescriptionProps) {
  return (
    <ContentContainer margin={margin} padding={padding}>
      <Typography variant="title" align="center">
        {title}
      </Typography>
      <Typography variant="description" align="center" maxWidht={descriptionMaxWidth}>
        {description}
      </Typography>
    </ContentContainer>
  );
}

TitleAndDescription.defaultProps = {};
export { TitleAndDescription };
